import type React from "react";
import { useEffect, useState } from "react";

import iconClock from "@/assets/icons/clock.svg";
import { Icon } from "@/components/Icon/Icon";
import { formatDistance } from "@/helpers/date";
import { useTranslation } from "@/translations";

interface CountdownLabelProps {
  endDate: Date;
}

export function CountdownLabel({ endDate }: CountdownLabelProps): React.ReactNode {
  const [nowDate, setNowDate] = useState(new Date());

  const { t } = useTranslation();

  useEffect(() => {
    const interval = setInterval(() => {
      setNowDate(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex w-fit items-center gap-1 rounded-md bg-aop-basic-blue-100 px-2 py-1 text-caption-bold text-aop-basic-blue-500">
      <Icon name={iconClock} size={16} />
      {endDate > nowDate ? (
        <span>
          {t("common.label.countdown", {
            distance: formatDistance(t, {
              start: endDate,
              end: nowDate,
            }),
          })}
        </span>
      ) : (
        <span>{t("common.label.ended")}</span>
      )}
    </div>
  );
}
